import { UiErrorMessageBuilder } from '../handlers/error/ui-error-message-builder';
import { HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { MessageService } from 'primeng/api';
import { catchError } from 'rxjs';

export const appErrorMessageInterceptor: HttpInterceptorFn = (req, next) => {
    const userErrorBuilder = inject(UiErrorMessageBuilder);
    const toastErrorService = inject(MessageService);

    return next(req).pipe(
        catchError((err) => {
            const errorMessage = userErrorBuilder.buildErrorMessage(err, req);
            if (!errorMessage.ignore) {
                toastErrorService.add({
                    summary: errorMessage.title?.trim() || 'Erro',
                    severity: errorMessage.severity || 'error',
                    detail: errorMessage.text,
                    life: 5000
                });
            } else if (err.status === 0) {
                toastErrorService.add({
                    summary: 'Erro',
                    severity: 'error',
                    detail: 'Verifique sua conexão e tente novamente.',
                    life: 5000
                });
            }
            throw err;
        })
    );
};
